'use client';
import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { footerTranslations as s } from "../helpers/translation.js";
import { socialLinks as n } from "../helpers/constants.js";
import { cn as i } from "@tameeni/shared-logic";
const p = ({
  locale: l,
  isMobile: a
}) => /* @__PURE__ */ o(
  "div",
  {
    className: i(
      "flex items-center lg:items-start gap-2 w-full lg:w-auto",
      a ? "flex-row" : "flex-col"
    ),
    children: [
      /* @__PURE__ */ e("p", { className: "text-gray-700 font-medium lg:mb-2 text-xs", children: s.followUs[l].label }),
      /* @__PURE__ */ e("div", { className: "flex gap-2", children: n.map((r, t) => /* @__PURE__ */ e(
        "a",
        {
          href: r.url,
          "aria-label": r.label,
          className: "text-gray-500 hover:text-gray-800",
          target: "_blank",
          rel: "noreferrer noopener",
          children: /* @__PURE__ */ e("span", { className: "h-6 w-6", "aria-hidden": "true", children: r.icon })
        },
        t
      )) })
    ]
  }
);
export {
  p as FollowUs
};
//# sourceMappingURL=social-follow-us.js.map
